'use client';

import type React from 'react';
import { Bets } from '../Bets';
import { Brands } from '../Brands';
import { BigWin } from '../WinLastes';
import { CategorySection } from './Category';
import { OfferSection } from './OfferSection';
import { Services } from './Services';
export const Home: React.FC = () => {
  return <>
      <OfferSection />
      <CategorySection />
      <BigWin />
      <Services />
      <Brands />
      <Bets hasActionTab />
    </>;
};